define("checkout/components/charges-summary", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "checkout/utils/upgrade-downgrade", "@ember/template-factory"], function (_exports, _component, _service, _component2, _upgradeDowngrade, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"checkout/utils/upgrade-downgrade",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="tCK--table__row" data-test-id="summary-of-todays-charges">
    <div class="tCK--table__data">
      {{#if (or @hasActiveTrial @isEligibleForTrial)}}
        <p class="u--text--light u--text--sm">
          <span>{{t "plans.checkout.plan.trial_disclaimer_short"}}</span>
          <span>
            {{this.trialChargesSummary}}
          </span>
        </p>
      {{else}}
        {{#if @hasCheckoutChanges}}
          <p class="u--text--light u--text--sm">
            {{#if @proration.isLoading}}
              {{t "plans.checkout.review_changes.loading"}}
            {{else}}
              {{this.chargesCopy}}
              {{#if @hasExpiringDiscount}}
                <br />
                {{this.expiringDiscountCopy}}
              {{/if}}
            {{/if}}
          </p>
        {{/if}}
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "eYUwOsaF",
    "block": "[[[10,0],[14,0,\"tCK--table__row\"],[14,\"data-test-id\",\"summary-of-todays-charges\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tCK--table__data\"],[12],[1,\"\\n\"],[41,[28,[37,1],[[30,1],[30,2]],null],[[[1,\"      \"],[10,2],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,2],[\"plans.checkout.plan.trial_disclaimer_short\"],null]],[13],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[30,0,[\"trialChargesSummary\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"        \"],[10,2],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n\"],[41,[30,4,[\"isLoading\"]],[[[1,\"            \"],[1,[28,[35,2],[\"plans.checkout.review_changes.loading\"],null]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[30,0,[\"chargesCopy\"]]],[1,\"\\n\"],[41,[30,5],[[[1,\"              \"],[10,\"br\"],[12],[13],[1,\"\\n              \"],[1,[30,0,[\"expiringDiscountCopy\"]]],[1,\"\\n\"]],[]],null]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@hasActiveTrial\",\"@isEligibleForTrial\",\"@hasCheckoutChanges\",\"@proration\",\"@hasExpiringDiscount\"],false,[\"if\",\"or\",\"t\"]]",
    "moduleName": "checkout/components/charges-summary.hbs",
    "isStrictMode": false
  });
  let ChargesSummaryComponent = _exports.default = (_class = class ChargesSummaryComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "plans", _descriptor3, this);
    }
    get upgradeMap() {
      const socialSetsUpgradeText = this.intl.t('checkout.summary.social_sets', {
        amount: Math.abs(this.args.proration.socialSetChange)
      });
      const usersUpgradeText = this.intl.t('checkout.summary.users', {
        amount: Math.abs(this.args.proration.userChange)
      });
      const aiCreditsUpgradeText = this.intl.t('checkout.summary.ai_credits', {
        amount: Math.abs(this.args.proration.aiCreditsChange)
      });
      return [{
        changesCopy: aiCreditsUpgradeText,
        isAdding: this.isAddingAiCredits
      }, {
        changesCopy: usersUpgradeText,
        isAdding: this.isAddingUsers
      }, {
        changesCopy: socialSetsUpgradeText,
        isAdding: this.isAddingSocialSets
      }].filter(addon => addon.isAdding);
    }
    get downgradeMap() {
      const socialSetsDowngradeText = this.intl.t('checkout.summary.social_sets', {
        amount: Math.abs(this.args.proration.socialSetChange)
      });
      const usersDowngradeText = this.intl.t('checkout.summary.users', {
        amount: Math.abs(this.args.proration.userChange)
      });
      const aiCreditsDowngradeText = this.intl.t('checkout.summary.ai_credits', {
        amount: Math.abs(this.args.proration.aiCreditsChange)
      });
      return [{
        changesCopy: aiCreditsDowngradeText,
        isRemoving: this.isAiCreditsDowngrade
      }, {
        changesCopy: usersDowngradeText,
        isRemoving: this.isUserDowngrade
      }, {
        changesCopy: socialSetsDowngradeText,
        isRemoving: this.isSocialSetDowngrade
      }].filter(addon => addon.isRemoving);
    }
    get expiringDiscountCopy() {
      return this.intl.t('checkout.discount.expiring', {
        date: this.args.remainingDiscountDuration,
        interval: this.args.selectedSubscriptionPlan?.intervalName,
        amount: this.args.amountWhenDiscountExpiresAfterTax
      });
    }
    get hasProratedTotal() {
      return this.args.proration.immediateAmount > 0;
    }
    get isAddingAiCredits() {
      return this.args.proration?.aiCreditsChange > 0;
    }
    get isAddingSocialSets() {
      return this.args.proration?.socialSetChange > 0;
    }
    get isAddingUsers() {
      return this.args.proration?.userChange > 0;
    }
    get isDowngrade() {
      return this.isIntervalDowngrade || this.isPlanDowngrade || this.isSocialSetDowngrade || this.isUserDowngrade || this.isAiCreditsDowngrade;
    }
    get isFree() {
      return !this.args.currentSubscriptionPlan?.isPaid;
    }
    get isPlanDowngrade() {
      return this.args.proration.isPlanDowngrade;
    }
    get isSocialSetDowngrade() {
      return this.args.proration.isSocialSetDowngrade;
    }
    get isIntervalDowngrade() {
      return this.args.proration.isIntervalDowngrade;
    }
    get isUserDowngrade() {
      return this.args.proration.isUserDowngrade;
    }
    get isAiCreditsDowngrade() {
      return this.args.proration.isAiCreditsDowngrade;
    }
    get isUpgrade() {
      const isPlanUpgrade = (0, _upgradeDowngrade.isUpgrade)(this.args.currentSubscriptionPlan, this.args.selectedSubscriptionPlan, this.plans.plans);
      const isIntervalUpgrade = this.args.currentSubscriptionPlan.isMonthly && this.args.selectedSubscriptionPlan.isYearly;
      return isPlanUpgrade || isIntervalUpgrade;
    }
    get trialChargesSummary() {
      const interval = this.args.selectedSubscriptionPlan?.intervalName;
      const date = this.auth.currentAccount?.trialExpiryMoment?.format('MMM DD, YYYY') ?? this.args.proration?.futureDate?.format('MMM DD, YYYY');
      const planName = this.args.selectedSubscriptionPlan?.displayName;
      const amount = this.args.proration?.futureAmountAfterTax;
      if (this.isPlanDowngrade) {
        if (this.downgradeMap.length === 3) {
          return this.intl.t('checkout.downgrade_trial.plan_three_addons', {
            date,
            planName,
            firstAddon: this.downgradeMap[0].changesCopy,
            secondAddon: this.downgradeMap[1].changesCopy,
            thirdAddon: this.downgradeMap[2].changesCopy,
            interval,
            amount
          });
        } else if (this.downgradeMap.length === 2) {
          return this.intl.t('checkout.downgrade_trial.plan_addons', {
            date,
            planName,
            firstAddon: this.downgradeMap[0].changesCopy,
            secondAddon: this.downgradeMap[1].changesCopy,
            interval,
            amount
          });
        } else if (this.downgradeMap.length === 1) {
          return this.intl.t('checkout.downgrade_trial.plan_addon', {
            date,
            planName,
            addon: this.downgradeMap[0].changesCopy,
            interval,
            amount
          });
        }
        return this.intl.t('checkout.downgrade_trial.plan', {
          date,
          planName,
          interval,
          amount
        });
      }
      if (this.downgradeMap.length === 3) {
        return this.intl.t('checkout.downgrade_trial.three_addons', {
          date,
          firstAddon: this.downgradeMap[0].changesCopy,
          secondAddon: this.downgradeMap[1].changesCopy,
          thirdAddon: this.downgradeMap[2].changesCopy,
          interval,
          amount
        });
      } else if (this.downgradeMap.length === 2) {
        return this.intl.t('checkout.downgrade_trial.addons', {
          date,
          firstAddon: this.downgradeMap[0].changesCopy,
          secondAddon: this.downgradeMap[1].changesCopy,
          interval,
          amount
        });
      } else if (this.downgradeMap.length === 1) {
        return this.intl.t('checkout.downgrade_trial.addon', {
          date,
          addon: this.downgradeMap[0].changesCopy,
          interval,
          amount
        });
      }
      return this.intl.t('checkout.downgrade_trial.interval', {
        date,
        interval,
        amount
      });
    }
    get downgradeSummary() {
      const interval = this.args.selectedSubscriptionPlan?.intervalName;
      const date = this.args.proration?.futureDate?.format('MMM DD, YYYY');
      const planName = this.args.selectedSubscriptionPlan?.displayName;
      const amount = this.args.proration?.futureAmountAfterTax;
      if (this.isPlanDowngrade) {
        if (this.downgradeMap.length === 3) {
          return this.intl.t('checkout.downgrade.plan_three_addons', {
            date,
            planName,
            firstAddon: this.downgradeMap[0].changesCopy,
            secondAddon: this.downgradeMap[1].changesCopy,
            thirdAddon: this.downgradeMap[2].changesCopy,
            interval,
            amount
          });
        } else if (this.downgradeMap.length === 2) {
          return this.intl.t('checkout.downgrade.plan_addons', {
            date,
            planName,
            firstAddon: this.downgradeMap[0].changesCopy,
            secondAddon: this.downgradeMap[1].changesCopy,
            interval,
            amount
          });
        } else if (this.downgradeMap.length === 1) {
          return this.intl.t('checkout.downgrade.plan_addon', {
            date,
            planName,
            addon: this.downgradeMap[0].changesCopy,
            interval,
            amount
          });
        }
        return this.intl.t('checkout.downgrade.plan', {
          date,
          planName,
          interval,
          amount
        });
      }
      if (this.downgradeMap.length === 3) {
        return this.intl.t('checkout.downgrade.three_addons', {
          date,
          firstAddon: this.downgradeMap[0].changesCopy,
          secondAddon: this.downgradeMap[1].changesCopy,
          thirdAddon: this.downgradeMap[2].changesCopy,
          interval,
          amount
        });
      } else if (this.downgradeMap.length === 2) {
        return this.intl.t('checkout.downgrade.addons', {
          date,
          firstAddon: this.downgradeMap[0].changesCopy,
          secondAddon: this.downgradeMap[1].changesCopy,
          interval,
          amount
        });
      } else if (this.downgradeMap.length === 1) {
        return this.intl.t('checkout.downgrade.addon', {
          date,
          addon: this.downgradeMap[0].changesCopy,
          interval,
          amount
        });
      }
      return this.intl.t('checkout.downgrade.interval', {
        date,
        interval,
        amount
      });
    }
    get chargesToday() {
      const planName = this.args.selectedSubscriptionPlan?.displayName;
      const amount = this.args.proration?.immediateAmountAfterTax;
      const chargesTodayPrefix = this.isFree ? 'plans.checkout.charges.today.from_free' : 'plans.checkout.charges.today.prorated';
      if (this.args.proration.immediateAmount > 0) {
        if (this.isUpgrade) {
          if (this.upgradeMap.length === 3) {
            return this.intl.t(`${chargesTodayPrefix}.upgrade_three_addons`, {
              amount,
              planName,
              firstAddon: this.upgradeMap[0].changesCopy,
              secondAddon: this.upgradeMap[1].changesCopy,
              thirdAddon: this.upgradeMap[2].changesCopy
            });
          } else if (this.upgradeMap.length === 2) {
            return this.intl.t(`${chargesTodayPrefix}.upgrade_two_addons`, {
              amount,
              planName,
              firstAddon: this.upgradeMap[0].changesCopy,
              secondAddon: this.upgradeMap[1].changesCopy
            });
          } else if (this.upgradeMap.length === 1) {
            return this.intl.t(`${chargesTodayPrefix}.upgrade_one_addon`, {
              amount,
              planName,
              addon: this.upgradeMap[0].changesCopy
            });
          }
          return this.intl.t(`${chargesTodayPrefix}.upgrade`, {
            amount,
            planName
          });
        }
        if (this.upgradeMap.length === 3) {
          return this.intl.t(`${chargesTodayPrefix}.three_addons`, {
            amount,
            firstAddon: this.upgradeMap[0].changesCopy,
            secondAddon: this.upgradeMap[1].changesCopy,
            thirdAddon: this.upgradeMap[2].changesCopy
          });
        } else if (this.upgradeMap.length === 2) {
          return this.intl.t(`${chargesTodayPrefix}.two_addons`, {
            amount,
            firstAddon: this.upgradeMap[0].changesCopy,
            secondAddon: this.upgradeMap[1].changesCopy
          });
        } else if (this.upgradeMap.length === 1) {
          return this.intl.t(`${chargesTodayPrefix}.one_addon`, {
            amount,
            addon: this.upgradeMap[0].changesCopy
          });
        }
      }
      return this.intl.t('plans.checkout.charges.today.no_charge');
    }
    get futureAmount() {
      const interval = this.args.selectedSubscriptionPlan?.intervalName;
      const date = this.args.proration?.futureDate?.format('MMM DD, YYYY');
      const amount = this.args.proration?.futureAmountAfterTax;
      if (this.args.hasActiveTrial && (this.isAddingSocialSets || this.isAddingUsers)) {
        return this.intl.t('plans.checkout.charges.future_trial');
      }
      return this.intl.t('plans.checkout.charges.future', {
        amount,
        date,
        interval
      });
    }
    get chargesCopy() {
      return `${this.chargesToday} ${this.isDowngrade ? this.downgradeSummary : this.futureAmount}`;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ChargesSummaryComponent);
});